export const FORM = "application/x-www-form-urlencoded";
export const JSON = "application/json";
export const XML = "text/xml";
export const TEXT = "application/text";
